import { render, staticRenderFns } from "./petra.vue?vue&type=template&id=5e34b060"
import script from "./petra.vue?vue&type=script&lang=js"
export * from "./petra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports